import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './error-handler.service';
import { AppConfigService } from './app-config.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

  getActiveFileIdsByDocIdAndType(docId: string, type: number): Observable<FileIdRank[]> {
    const url = `${this.appConfigService.getConfig().webApi}/api2/Docs/${docId}/Files?typeId=${type}`;
    return this.http.get<FileIdRank[]>(url).pipe(catchError(this.errorHandler.handleError<FileIdRank[]>(`Get File Ids by doc and type`)));
  }
}

export interface FileIdRank {
  fileId: string,
  rank: number
}
